<script setup lang="ts">
type Emits = {
  continue: [];
  close: [];
};

const emit = defineEmits<Emits>();
</script>

<template>
  <ClientOnly>
    <div :class="$style.quitModalContent">
      <div :class="$style.modalInner">
        <img
          alt="Quit icon"
          aria-hidden="true"
          :class="$style.modalIcon"
          :src="getAssetsUrlForCDN('/assets/images/svg/quit.svg')"
        />

        <h6 :class="$style.modalTitle">
          {{ $t('auth.register.quit.title') }}
        </h6>

        <button
          :class="$style.continueButton"
          @click="emit('continue')"
        >
          {{ $t('auth.register.quit.cancel') }}
          <NuxtIcon name="arrows/arrow_right" />
        </button>

        <button
          :class="$style.cancelButton"
          @click="emit('close')"
        >
          <NuxtIcon name="close" />
          {{ $t('auth.register.quit.confirm') }}
        </button>
      </div>
    </div>
  </ClientOnly>
</template>

<style module lang="postcss">
.quitModalContent {
  @apply w-full h-full absolute top-0 left-0 z-50 bg-auth-bg-primary/95 p-6 text-center flex flex-col justify-center items-center;

  &:before {
    @apply content-[''] absolute top-0 left-0 w-full h-full bg-black/30 z-10;
  }

  .modalInner {
    @apply w-full max-w-80 flex flex-col gap-4 relative z-20;

    .modalIcon {
      @apply w-28 h-28 mx-auto;
    }

    .modalTitle {
      @apply text-2xl md:text-2xl font-semibold tracking-tight text-auth-texts mb-4 md:mb-3;
    }

    .continueButton {
      @apply h-[50px] bg-auth-button-bg text-auth-button-text w-full rounded-lg font-bold flex items-center justify-center gap-2;
    }

    .cancelButton {
      @apply text-auth-texts/70 text-sm cursor-pointer flex items-center justify-center gap-1;
    }
  }
}
</style>
